<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 96 960 960"
    width="24"
    fill="currentColor"
  >
    <path d="M452 868q-11-11-11.5-28t10.5-28l196-196H200q-17 0-28.5-11.5T160 576q0-17 11.5-28.5T200 536h447L451 340q-11-11-10.5-28t11.5-28q11-11 28-11t28 11l264 264q6 5 8.5 12.5T783 576q0 8-2.5 15t-8.5 13L508 868q-11 11-28 11t-28-11Z" />
  </svg>
</template>

<script>
  export default {
    name: 'ArrowForward'
  }
</script>
